import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Overline } from "./Reveal";

const PORTRAIT =
  "https://customer-assets.emergentagent.com/job_trading-mastery-hub-9/artifacts/io04yqr2_20260323_Danang%20nomad%20fest3967.webp";

const CREDS = [
  { k: "01", t: "Stock Investor & Options Trader", d: "25+ years mastering the markets." },
  { k: "02", t: "Professional Wealth Advisor", d: "Certified Financial Planner since age 20." },
  { k: "03", t: "Ex-IT Consultant", d: "A structured, systems-driven approach to trading." },
  { k: "04", t: "Certified Coach (ICF)", d: "Mentoring with accountability and clarity." },
  { k: "05", t: "Financially Free since 2020", d: "Living the strategy he teaches." },
  { k: "06", t: "Based in Singapore, Asia", d: "Coaching a global cohort across time zones." },
];

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section id="about" ref={ref} data-testid="about-section" className="relative py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
        {/* Portrait */}
        <div className="lg:sticky lg:top-28">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-3 bg-[radial-gradient(circle_at_50%_20%,rgba(56,189,248,0.35),transparent_60%)] blur-2xl" />
              <div className="relative overflow-hidden rounded-t-[220px] rounded-b-3xl border border-white/10 bg-surface">
                <motion.img
                  style={{ y: imgY, scale: 1.12 }}
                  src={PORTRAIT}
                  alt="Diego Taira"
                  className="w-full h-[560px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-transparent" />
              </div>
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                <div>
                  <p className="font-display italic text-3xl text-white">Diego Taira</p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-burgundy">
                    Wealth × Coach
                  </p>
                </div>
                <span className="font-mono text-xs text-slate-300">Singapore</span>
              </div>
            </div>
          </Reveal>
        </div>

        {/* Text */}
        <div>
          <Reveal>
            <Overline>Who Am I</Overline>
            <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-tight text-white mt-5">
              A trader&apos;s discipline. A coach&apos;s patience.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-slate-300 text-base md:text-lg leading-relaxed mt-8">
              Diego began his journey at 20 as a Certified Financial Planner and
              spent decades mastering the fundamentals of great businesses.
              Driven by a relentless pursuit of excellence, he evolved beyond
              traditional investing into <em className="italic text-white">investrading</em> —
              combining ownership with options strategies to generate income
              while growing capital.
            </p>
          </Reveal>

          <div className="mt-12 divide-y divide-white/10 border-t border-white/10">
            {CREDS.map((c, i) => (
              <Reveal key={c.k} delay={i * 0.06}>
                <div className="group flex items-start gap-6 py-5">
                  <span className="font-mono text-xs text-burgundy pt-1">{c.k}</span>
                  <div>
                    <h3 className="font-body text-lg md:text-xl text-white group-hover:text-burgundy transition-colors duration-300">
                      {c.t}
                    </h3>
                    <p className="text-slate-400 text-sm mt-1">{c.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
